var Handlebars = require("handlebars/dist/handlebars.runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<block-shape class=\"c-block-bottom-middle\">\r\n  <shape-solid></shape-solid>\r\n</block-shape>";
},"useData":true});